define('glu/browser',[],function() {
    'use strict';

    function getSimplifiedAgent() {
        var userAgent = browser.userAgent;

        if (userAgent.match(/Opera|Navigator|Minefield|KHTML|Chrome/)) {
            userAgent = userAgent.replace(/(Firefox|MSIE|KHTML,\slike\sGecko|Konqueror)/, '')
                .replace('Chrome Safari', 'Chrome')
                .replace('Minefield', 'Firefox')
                .replace('Navigator', 'Netscape')
                .replace('KHTML', 'Konqueror');
        }

        return userAgent.toLowerCase();
    }

    function getName(userAgent) {
        var name = (/(camino|chrome|crios|firefox|netscape|konqueror|lynx|msie|trident|opera|safari|phantomjs)/).exec(userAgent);
        if (!name || !name.length || name.length < 2) {
            return 'other';
        }

        return name[1].replace('trident', 'msie');
    }

    function getVersion(userAgent, browser) {
        if (browser.opera) {
            return window.opera.version();
        }

        try {
            return (/(camino|chrome|crios|firefox|netscape|netscape6|opera|version|konqueror|lynx|msie|rv|safari|phantomjs)(:|\/|\s)([a-z0-9\.\+]*?)(\;|dev|rel|\s|$)/).exec(userAgent)[3];
        } catch (e) {
            return null;
        }
    }

    var browser = {
        userAgent: window.navigator.userAgent
    };

    var agent = getSimplifiedAgent();

    // Set browser name flag (e.g. firefox: true)
    browser[getName(agent)] = true;

    // Set browser version (fullVersion is the original string, version is an numeric representation)
    browser.fullVersion = getVersion(agent, browser);
    browser.version = parseFloat(browser.fullVersion);

    browser.isIECompatibilityMode = function() {
        if (!this.msie) {
            return false;
        }

        var agentLowerCase = this.userAgent.toLowerCase();

        // Check if Trident version mismatches the actual browser version
        if (this.version === 8 && agentLowerCase.indexOf('trident/4.0') === -1 ||
            this.version === 9 && agentLowerCase.indexOf('trident/5.0') === -1 ||
            this.version === 10 && agentLowerCase.indexOf('trident/6.0') === -1 ||
            this.version === 11 && agentLowerCase.indexOf('trident/7.0') === -1) {
            return true;
        }

        return false;
    };

    return browser;
});

